import { saveAs } from "file-saver";
import JSZip from "jszip";
import axios from "axios";
import XLSX from "xlsx";
import { Message } from "element-ui";
import apiBaseURL from "@/utils/baseUrl.js";
import commonConfig from "@/const/config.js";

const exportDomain = process.env.VUE_APP_EXPORT_DOMAIN;
/**
 * 将arraybuffer下载为Excel
 * @date 2021-02-15
 * @param {object} dataObject {data, filename}
 * @returns {void}
 */
export const downloadArrayBuffer = function downloadArrayBuffer(dataObject) {
  const blob = new Blob([dataObject.data], {
    // type: "application/vnd.ms-excel",
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
    // type: "text/csv;charset=utf-8",
  });

  saveAs(blob, dataObject.filename);
};

/**
 * 通过get方法下载Excel
 * @date 2021-02-15
 * @param {string} path api路径
 * @param {object} queryObject 参数对象
 * @returns {void}
 */
export const exportExcel = function exportExcel(path, queryObject = {}) {
  const formatPath = /^\//.test(path) ? path : `/${path}`;
  const queryString = Object.keys(queryObject)
    .map((key) => `${key}=${queryObject[key]}`)
    .join("&");
  console.log(1111, exportDomain);
  window.open(
    `${
      process.env.NODE_ENV === "production"
        ? apiBaseURL
        : exportDomain.replace(/(^['"]|['"]$)/g, "")
    }${formatPath}?${queryString}`
  );
};

export const dataToExcel = function dataToExcel({
  title = "",
  subject = "",
  author = "",
  sheetName = "工作簿1",
  data = [],
  filename = "",
} = {}) {
  // 创建工作簿
  const wb = XLSX.utils.book_new();
  // 工作簿的属性
  wb.Props = {
    Title: title,
    Subject: subject,
    Author: author,
    CreatedDate: new Date(),
  };
  // 创建工作表
  wb.SheetNames.push(sheetName);

  // 工作表数据
  wb.Sheets[sheetName] = XLSX.utils.aoa_to_sheet(data);

  const wbout = XLSX.write(wb, {
    bookType: "xlsx",
    type: "binary",
  });

  function s2ab(s) {
    const buf = new ArrayBuffer(s.length); // convert s to arrayBuffer
    const view = new Uint8Array(buf); // create uint8array as viewer
    // eslint-disable-next-line no-bitwise
    for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff; // convert to octet
    return buf;
  }
  saveAs(
    new Blob([s2ab(wbout)], {
      type: "application/octet-stream",
    }),
    filename
  );
};

const getFile = (url) => {
  return new Promise((resolve, reject) => {
    const obj = {
      method: "get",
      url,
      // responseType: 'blob'
      responseType: "arraybuffer",
    };
    axios(obj)
      .then((data) => {
        resolve(data.data);
      })
      .catch((error) => {
        reject(error.toString());
      });
  });
};
/**
 * 批量导出jszip打包 下载图片
 * @date 2022-04-18
 * @param {array} exportDataList 图片列表
 * @param {array} exportRenameList 图片重命名列表
 * @param {string} exportFileName 导出文件重命名
 */
export const batchExportToZip = function batchExportToZip(
  exportDataList,
  exportRenameList,
  exportFileName
) {
  console.log("exportRenameList", exportRenameList);
  if (exportDataList.length <= 0) {
    Message.error("导出数据为空，请先查询再进行导出操作。");
    return;
  }
  const zip = new JSZip();
  const cache = {};
  const promises = [];

  exportDataList.forEach((item, index) => {
    const promise = getFile(item).then((data) => {
      let fileName = "";
      if (exportRenameList) {
        fileName = exportRenameList[index];
      } else {
        // 如果没有重命名的入参，则取获取文件名为导出命名
        // todo 这里有个小坑 这里适用以下格式 搭配命名入参使用没有问题 后续补个取文件名的方法吧
        // https://img4.yishouapp.com/oss/suzaku/20210408/5963a77a53a3b0819633f0d6bb9c4caa.jpg?x-image-process=image/resize,w_600
        const dataNameArray = item.split("/"); // 下载文件, 并存成ArrayBuffer对象
        const imgName = dataNameArray[dataNameArray.length - 2].split("?");
        fileName = imgName[0];
      }
      zip.file(fileName, data, { binary: true }); // 逐个添加文件
      cache[fileName] = data;
    });
    promises.push(promise);
  });
  Promise.all(promises).then(() => {
    zip.generateAsync({ type: "blob" }).then((content) => {
      // 生成二进制流
      saveAs(content, exportFileName || "文件下载.zip"); // 利用file-saver保存文件  自定义文件名
    });
  });
};

/**
 * 打开下载窗口
 */
export const openDownloadWindow = (res) => {
  const file = typeof res === "string" ? res : res.file;
  if (file) {
    const host =
      process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test"
        ? commonConfig.erpExportBaseUrl
        : apiBaseURL;
    const url = /http/.test(file) ? file : `${host}${file}`;
    window.open(url);
  }
};

/**
 * @description url地址下载，可以解决浏览器阻止弹窗
 * @param {String} url 下载路径
 */
export const downloadByUrl = (url) => {
  // check if url contains hostname
  let _url = url;
  if (url.indexOf("//") === -1 && url.indexOf("http://") === -1) {
    _url = `${apiBaseURL}${_url}`;
  }

  const a = document.createElement("a");
  a.download = Date.now();
  a.href = _url;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    document.body.removeChild(a);
  }, 1000);
};



// WEBPACK FOOTER //
// ./src/utils/export.js